<template>
	<div class="section">
		<div class="container">
			<h1>About the Index</h1>
			<p>
				The Cape Town Convention Compliance Index, developed by the Aviation Working Group (
				<b>AWG</b>
				), monitors and assesses compliance by contracting states to the Convention on International
				Interests in Mobile Equipment and Aircraft Protocol (collectively, the CTC) with their
				respective undertakings thereunder. With input on legal facts from over 200 law firms
				worldwide and following a rigorous methodological process, the Index assigns a score
				reflecting AWG's assessment of the likelihood of compliance with CTC obligations to each
				contracting state.
			</p>
			<p>
				The Index provides an objective, data-driven assessment of legal risk, which will be central
				to transactional analyses. It will be updated twice a year, in each of March and September.
			</p>
			<p>
				Drawing on AWG's long experience with CTC implementation and its extensive global supporting
				legal network, the Index is a critical step forward in centralizing and analyzing data on
				compliance with CTC worldwide and is an essential resource for understanding and assessing
				CTC-related issues in contracting states.
			</p>
			<h2>Additional Resources</h2>
			<p>
				<a target="_blank" href="http://www.awg.aero">Aviation Working Group main site</a>
			</p>
			<p>
				<a
					target="_blank"
					href="https://www.unidroit.org/instruments/security-interests/cape-town-convention">
					Convention on International Interests in Mobile Equipment (UNIDROIT)
				</a>
			</p>
			<p>
				<a
					target="_blank"
					href="https://www.unidroit.org/instruments/security-interests/aircraft-protocol">
					Aircraft Equipment Protocol (UNIDROIT)
				</a>
			</p>
			<p>
				<a
					target="_blank"
					href="https://www.oecd.org/officialdocuments/publicdisplaydocumentpdf/?cote=TAD/PG(2022)1&docLanguage=en">
					Aircraft Sector Understanding (OECD) - please see page 41
				</a>
			</p>
			<p>
				<a target="_blank" href="http://www.ctcap.org/">Cape Town Convention Academic Project</a>
			</p>
			<p>
				<a target="_blank" href="https://www.internationalregistry.aero/ir-web/">
					International Registry
				</a>
			</p>
		</div>
	</div>
</template>

<script>
	export default {
		created() {},
		mounted() {}
	};
</script>
